import { Select, Card, Col, Form, Input, Row } from "antd";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MgmtService from "../../../../app/service/mgmtService";
import { Button } from "../../../../components";
import MgmtLayout from "../../../../components/layouts/MgmtLayout";
import { messageError, messageSuccess } from "../../../../components/toastr";

export const MgmtPlatesUpdate = () => {
    let history = useHistory();
    const mgmtService = new MgmtService();
    const [loading, setLoading] = useState(false);
    const [plates, setPlates] = useState([]);
    const descriptions = [{ label: "Veículo", value: "vehicle" }, { label: "Torre de Iluminação", value: "lightingtower" }, { label: "Compressor", value: "compressor" },
    { label: "Gerador", value: "electricGenerator" }];

    const submitPlate = (data) => {
        setLoading(true);

        mgmtService.updatePlate(data).then(res => {
            if (res && res.status === 200) {
                messageSuccess('Placa alterada com sucesso.');
            } else {
                messageError('Erro ao alterar placa.');
            }

            setLoading(false);
        }).catch(err => {
            setLoading(false);
        });
    }

    useEffect(() => {
        mgmtService.getPlates().then(res => {
            let plates = [];

            res.data.data.forEach(item => {
                plates.push({
                    label: item.plate,
                    value: item.plateId,
                    description: item.description,
                    client: item.clientName,
                    clientId: item.clientId,
                });
            });
            setPlates(plates);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    return (
        <MgmtLayout>
            <Card title='Alteração de Placa'>
                <Form onFinish={(data) => submitPlate(data)} layout="vertical">
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Placa</b>} name="plateId">
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                    }
                                    allowClear
                                    placeholder="Selecione uma Placa"
                                    options={plates ? plates : null}
                                    style={{ width: '90%' }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Descrição</b>} name="description">
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    allowClear
                                    placeholder="Selecione uma descrição"
                                    options={descriptions ? descriptions : null}
                                    style={{ width: '90%' }}
                                />
                            </Form.Item>
                        </Col>

                        <Col style={{ display: 'flex', justifyContent: 'end' }} span={24}>
                            <Button onClick={() => history.goBack()} style={{ marginRight: '10px' }}>Voltar</Button>
                            <Button htmlType='submit' loading={loading} className='successButton' onClick={() => history.goBack()}>Salvar</Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </MgmtLayout>
    );
}